module.exports = __webpack_public_path__ + "img/icon-useroverviewAsset 43.20aa47c6.svg";